<div   fxLayout="column" id="descdialog">
  <div class="dialog-title">
    <h3>Description</h3>
    <button mat-icon-button
            mat-dialog-close
            class="close-dialog">
      <mat-icon>close</mat-icon>
    </button>
  </div>
  <div mat-dialog-content>
    <p>{{serviceDescription}}</p>
  </div>
  
</div>
  
